import { inject } from '@angular/core';
import type { CanActivateFn} from '@angular/router';
import { Router } from '@angular/router';

import { AuthStore } from './auth.store';

/**
 * Guard funcional: exige sesión válida. Sin sesión:
 * - modo local (`auth.mode: 'local'`) → redirige a la pantalla propia `/auth/login`;
 * - modo OIDC → dispara el authorize del IdP.
 * En ambos casos guarda la URL destino para volver tras el login.
 */
export const authGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthStore);
  const router = inject(Router);

  if (auth.isAuthenticated()) {
    return true;
  }

  // Persistir destino para post-login redirect.
  sessionStorage.setItem('pvp:redirect-url', state.url);

  if (auth.isLocalMode()) {
    return router.parseUrl('/auth/login');
  }

  auth.login();
  // Bloquear la navegación local mientras el IdP toma control.
  return router.parseUrl('/');
};
